<template>
  <div style="display:flex;flex-flow:row;align-items: stretch;" class="collapse-menu">
    <div>
      <i class="ui ellipsis vertical icon"></i>
    </div>
    <div style="display:flex;flex-flow:row;align-items: stretch;" class="collapse-menu-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
    export default {
        name: "collapse-element"
    }
</script>

<style scoped>
  .collapse-menu{
    width: fit-content;
    transition: all .5s;
    transition-delay: 0.8s;
    border-radius:4px;
    box-shadow: 0 0 0 0 transparent;
  }
  collapse-menu:hover,.collapse-menu[data-open='true']{
    transition-delay:0.2s;
    box-shadow: #d4d4d4c7 2px 4px 10px 3px;
  }
  .collapse-menu .collapse-menu-content{
    transition: all .5s;
    transition-delay:1s;
    width:0;
    transform: scaleX(0);
    transform-origin: top left;
    padding:0;
    background: #ffffffee;
  }
  .collapse-menu[data-open='true'] .collapse-menu-content,
  .collapse-menu:hover .collapse-menu-content{
    opacity: 1;
    transform: none;
    transition-delay:0s;
    width: 100%;
    padding:0 8px;
  }

  .collapse-menu[data-open='true']{
    box-shadow: none;
  }
</style>
